<template>
  <header class="container-fluid bg-dark text-light py-2">
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center"
    >
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center" role="banner">
          <img
            src="@/assets/logo-dark.svg"
            alt="Oregon State University Logo"
            height="30"
            class="d-none d-sm-inline-flex align-top me-3 pe-3 border-end"
          />
          <img
            src="@/assets/logo-dark.svg"
            alt="Oregon State University Logo"
            height="40"
            class="d-inline-flex d-sm-none align-top me-3 pe-3 border-end"
          />
          <div class="d-none d-sm-block title me-3 fw-bold">{{ course }}</div>
          <div class="subtitle d-none d-sm-block">{{ title }}</div>
          <div class="d-flex flex-column d-sm-none align-items-start">
            <div class="title me-3 fw-bold fs-6">{{ course }}</div>
            <div class="subtitle fs-6">{{ shortTitle }}</div>
          </div>
        </div>
      </div>
      <div
        class="d-flex align-items-center gap-3 mt-2 mt-md-0 flex-wrap justify-content-end"
      >
        <div
          v-if="showLabAttemptNav"
          class="d-flex align-items-center gap-3 flex-wrap justify-content-end flex-shrink-0"
        >
          <strong v-if="currentLabAttempt" class="small text-light">
            Attempt {{ currentAttemptNumber }} of {{ maxAttempts }}
          </strong>

          <LabProgressBar
            v-if="showLabProgressBar"
            class="my-0 px-0 flex-shrink-1 min-w-0"
            :current-passage="context?.current || 'start'"
            :context="context"
            :progress-steps="progressSteps"
          />

          <div class="header-progress-nav-divider border-start border-light" />

          <router-link
            class="btn btn-sm btn-link fw-bold text-nowrap link-light px-0"
            :to="{ name: 'LabAttempts' }"
          >
            View lab attempts
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/data/config";
import LabProgressBar from "@/components/activity/LabProgressBar.vue";

const LAB_TITLE = import.meta.env.VITE_LAB_TITLE;
const LAB_SHORT_TITLE = import.meta.env.VITE_LAB_SHORT_TITLE;

export default {
  name: "TheHeader",
  components: {
    LabProgressBar
  },
  data() {
    return {
      course: config.meta.course,
      title: LAB_TITLE ?? config.meta.title,
      shortTitle: LAB_SHORT_TITLE ?? config.meta.shortTitle
    };
  },
  computed: {
    ...mapGetters([
      "getCurrentLabAttempt",
      "labAttempts",
      "maxAttempts",
      "context",
      "inMobileView",
      "storyEngineActive",
      "progressSteps"
    ]),
    currentLabAttempt() {
      return this.getCurrentLabAttempt;
    },
    currentAttemptNumber() {
      if (!this.currentLabAttempt) return 0;
      return (
        this.labAttempts.findIndex(
          (attempt) => attempt.attemptId === this.currentLabAttempt.attemptId
        ) + 1
      );
    },
    showLabAttemptNav() {
      const n = this.$route.name;
      return n === "Activity" || n === "ActivityPreview" || n === "LabAttempts";
    },
    showLabProgressBar() {
      const n = this.$route.name;
      const onActivity = n === "Activity";
      return (
        onActivity &&
        !this.inMobileView &&
        this.storyEngineActive &&
        this.progressSteps.length > 0
      );
    },
    env() {
      let showLabel = import.meta.env.VITE_SHOW_ENV_LABEL;

      if (showLabel === "false" || showLabel === false) {
        return false;
      }

      const host = window.location.host;
      const subdomain = host.split(".")[0];

      switch (subdomain) {
        case "testing":
          return "test";
        case "demo":
          return "demo";
        case "web":
          return false;
        default:
          return "development";
      }
    }
  }
};
</script>

<style scoped>
.header-progress-nav-divider {
  min-height: 1.5rem;
}
</style>
